import React, { useEffect } from "react";

import { useLocation } from "@reach/router";
import {
  updateParentUrl,
  webBridge,
} from "../../bridges/BridgeMethods/InitializeWeb";
import { isWeb } from "../../bridges/BridgeServices";
import { BRIDGE_NAME } from "../../bridges/bridgeConstants";
import { bridgeHandler } from "../../bridges/bridgeManager";
import { ticketsUrl } from "../../bridges/deeplinkUrlConfig";
import { isTokenPresent } from "../../utils/cookieHelper";
import Seo from "../seo";
import LoginHeader from "./LoginHeader";
import "./header.scss";
const Header = () => {
  const location = useLocation();

  const createTicketUrl = () => {
    const ticketId =
      typeof window !== "undefined"
        ? new URLSearchParams(window.location.search).get(
            "ticketId"
          )
        : "";
    const src = `${ticketsUrl}${
      ticketId ? `/${ticketId}` : ""
    }`;

    return src;
  };

  useEffect(() => {
    window[BRIDGE_NAME] = bridgeHandler;
    if (isWeb()) {
      webBridge();
    }
  }, []);
  useEffect(() => {
    if (isWeb()) {
      updateParentUrl(location.pathname);
    }
  }, [location.pathname]);
  return (
    <div className="header-container">
      <Seo title="Share.Market" />
      {isWeb() && !isTokenPresent() && <LoginHeader />}

      {isWeb() && (
        <div className="header">
          <div className="header-heading">Help Center</div>
          {isTokenPresent() && (
            <div className="view-tickets">
              <a
                href={createTicketUrl()}
                target="_blank"
                rel="noreferrer"
              >
                View Your Tickets
              </a>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Header;
